<div *ngIf="shouldShowStandardDialog" class="header">
    <!--Dialog-box title-->
    <h2 mat-dialog-title>{{title}}</h2>

    <!--Dialog-box message-->
    <div mat-dialog-content>
        <p>{{message}}</p>
    </div>

    <!--Yes and no buttons for dialog box confirmation-->
    <div mat-dialog-actions class="buttons">
        <button mat-raised-button color="primary" (click)="onConfirm()">Yes</button>
        <button mat-raised-button (click)="onDismiss()">No</button>
    </div>
</div>

<div class="margin-4" fxLayout="column" *ngIf="data?.isPageTour">
    <div fxLayoutAlign="end">
        <button class="pos-right btn-plane cursor" (click)="onDismiss()">
            <em class="fa fa-times" aria-hidden="true"></em>
        </button>
    </div>
</div>

<div *ngIf="data?.isAuth">
    <div mat-dialog-content>
        <p>{{message}} <button mat-button color="primary" (click)="onDismiss()">Login</button></p>
    </div>
</div>


<div *ngIf="page === 'wfRun'">
    <app-table-normal [dataSource]="dataSource" [columnHeaders]="dynamicColumnHeaders"
        [columnsToDisplay]="dynamicColumnsToDisplay"></app-table-normal>
</div>